import { fetchWithToken, getFormsUrl } from '@adsk/acs-sc-web-platform-api';

import buildSearchParams from './buildSearchParams';
import { APSV2Form, CreateFormV2RequestBody } from '../types';
import createFormTransformer from './transformers/createForm';
import { GetFoldersV1Response } from './transformers/getFolders';
import getFormsTransformer from './transformers/getForms';
import updateFormTransformers from './transformers/updateForm';

export const formsRoutes = {
  folders: (projectId: string, folderId?: string) =>
    folderId
      ? `${getFormsUrl()}/development/v1/projects/${projectId}/folders/${folderId}`
      : `${getFormsUrl()}/development/v1/projects/${projectId}/folders`,
  formTemplates: (projectId: string) =>
    `${getFormsUrl()}/legacy/v1/projects/${projectId}/form-templates`,
  updateSingleFormDetail: (
    projectId: string,
    formTemplateId: string,
    formId: string,
  ) =>
    `${getFormsUrl()}/development/v2/projects/${projectId}/form-templates/${formTemplateId}/forms/${formId}`,
};

const formsRoutesScalingFormsM7 = {
  createForm: (projectId: string, formTemplateId: string) =>
    `${getFormsUrl()}/development/v2/projects/${projectId}/form-templates/${formTemplateId}/forms`,
  allInProjectForType: (projectId: string) =>
    `${getFormsUrl()}/development/v2/projects/${projectId}/forms`,
};

export const formsClient = {
  createForm: (
    projectId: string,
    formTemplateId: string,
    body: CreateFormV2RequestBody,
  ) =>
    fetchWithToken(
      `${formsRoutesScalingFormsM7.createForm(projectId, formTemplateId)}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(createFormTransformer.translateBody(body)),
      },
    ) as Promise<APSV2Form>,
  getFormTemplates: (
    projectId: string,
    params: Record<string, string | number> = {},
  ) =>
    fetchWithToken(
      `${formsRoutes.formTemplates(projectId)}?${buildSearchParams(params)}`,
    ),
  getFormsScalingFormsM7: (
    projectId: string,
    params: Record<string, string | number> = {},
  ) => {
    return fetchWithToken(
      `${formsRoutesScalingFormsM7.allInProjectForType(
        projectId,
      )}?${buildSearchParams(
        getFormsTransformer.translateQueryParams(params),
      )}`,
    );
  },
  getFolders: async (
    projectId: string,
    params: { offset: number; limit: number },
  ) =>
    fetchWithToken<GetFoldersV1Response>(
      `${formsRoutes.folders(projectId)}?${buildSearchParams(params)}`,
    ),
  updateFormDetails: (
    projectId: string,
    formTemplateId: string,
    formId: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params: any,
  ) =>
    fetchWithToken<APSV2Form>(
      `${formsRoutes.updateSingleFormDetail(
        projectId,
        formTemplateId,
        formId,
      )}?${buildSearchParams(params)}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
        body: JSON.stringify(updateFormTransformers.translateBody(body)),
      },
    ),
};
